import { render, staticRenderFns } from "./DataTableSearchBox.vue?vue&type=template&id=63772ee1"
import script from "./DataTableSearchBox.vue?vue&type=script&lang=js"
export * from "./DataTableSearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports